module.exports = __webpack_public_path__ + "img/Network-Icon.svg";